/* MH · Pop-up nach „In den Warenkorb“ als Angebotsfläche · Stand 14.10.2026
   ---------------------------------------------------------------------------
   Auslöser: JEDES erfolgreiche Hinzufügen über /cart/add (fetch oder XHR) – Produktseite, Sticky-Button,
   Collection-Karte, Quick-Buy, Startseite, Suche, Landingpages mit eigenem Warenkorb-Knopf.
   Kein Pop-up, wenn: Warenkorbseite, Seite wird gerade verlassen (Weiterleitung nach dem Hinzufügen),
   Artikel ist Zubehör/Gutschein (Einstellung), kostet 0 € (Gratis-Beigabe), trägt _q / _upsell_for / __as*
   (also ein Zubehör-Weg, auch aus diesem Pop-up selbst).
   Inhalt: /products/<handle>?view=mh-atc&variant=<id> (templates/product.mh-atc.liquid), ohne Cache.
   Bis der Inhalt da ist, zeigt das Pop-up den Artikel aus der Antwort von /cart/add und Platzhalter.
   Dazulegen: /cart/add.js mit Property _q=popup (Messung), Geschenk-Artikel mit _upsell_for + „Gehört zu“.
   Danach cart:updated + cart:refresh (Theme zählt den Warenkorb neu) und der Inhalt wird frisch geladen.
   Zugänglichkeit: role=dialog, Fokus im Dialog, Esc, Klick auf den Hintergrund, Fokus zurück zum Auslöser.
   14.10.2026 (Ruhige Journey): Fußzeile „Im Warenkorb: N Artikel · Betrag“ nach jedem Hinzufügen aus /cart.js nachziehen;
   Zeile des hinzugefügten Artikels grün (is-ok); offene Frage-Zeilen (<details data-mh-atc-frage>) bleiben nach dem
   Nachladen offen – außer die Zeile meldet „liegt bei“ (data-dabei), die bleibt zu. Kein automatisches Öffnen. */
(function () {
  'use strict';
  if (window.__mhAtcGeladen) { return; }
  window.__mhAtcGeladen = true;

  var doc = document;
  var root = doc.getElementById('mh-atc');
  var konfigEl = doc.getElementById('mh-atc-konfig');
  if (!root || !konfigEl) { return; }
  var cfg = {};
  try { cfg = JSON.parse(konfigEl.textContent || '{}'); } catch (e) { cfg = {}; }

  var wurzel = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || cfg.wurzel || '/';
  if (wurzel.charAt(wurzel.length - 1) !== '/') { wurzel += '/'; }
  var ohneTypen = String(cfg.ohneTypen || 'Zubehör, Geschenkgutschein').toLowerCase().split(',').map(function (s) { return s.replace(/^\s+|\s+$/g, ''); });
  var dialog = root.querySelector('.mh-atc__dialog');
  var body = root.querySelector('[data-mh-atc-body]');
  var live = root.querySelector('[data-mh-atc-live]');
  var korbLink = root.querySelector('[data-mh-atc-korb]');
  var origFetch = window.fetch ? window.fetch.bind(window) : null;

  var offen = false;         /* Pop-up soll offen sein (auch während das CSS noch lädt) */
  var sichtbar = false;      /* Pop-up ist auf dem Bildschirm */
  var aktuell = null;        /* { handle, variante, typ } */
  var ausloeser = null;
  var verlassen = false;
  var laufend = 0;           /* laufende Dazulegen-Anfragen */
  var wartendAufKorb = null;
  var ladeNr = 0;
  var letzterKlick = null;   /* Auslöser merken: das Theme sperrt den Kaufknopf während des Hinzufügens, dann hat er keinen Fokus */

  doc.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('button, a[href], [role="button"]') : null;
    if (b && !root.contains(b)) { letzterKlick = b; }
  }, true);

  /* Seite wird verlassen (z. B. Weiterleitung direkt nach dem Hinzufügen): kein Pop-up.
     beforeunload nur kurz um ein Hinzufügen herum, damit der Back-Forward-Cache des Browsers nicht leidet. */
  function merkeVerlassen() { verlassen = true; }
  window.addEventListener('pagehide', merkeVerlassen);
  window.addEventListener('pageshow', function () { verlassen = false; if (korbLink) { korbLink.classList.remove('is-laedt'); } });
  function horche(an) { if (an) { window.addEventListener('beforeunload', merkeVerlassen); } else { window.removeEventListener('beforeunload', merkeVerlassen); } }

  /* ---------- Auslöser: /cart/add beobachten ---------- */
  function istAdd(url, methode) {
    return String(methode || 'GET').toUpperCase() === 'POST' && /\/cart\/add(\.js|\.json)?(\?|#|$)/.test(String(url || ''));
  }

  if (origFetch) {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || String(input || '');
      var methode = (init && init.method) || (input && typeof input === 'object' && input.method) || 'GET';
      var add = istAdd(url, methode);
      /* Das Theme ruft nach dem Hinzufügen über eine Collection-Karte reinitialiseRatingSnippet (reviews.io) auf.
         Fehlt reviews.io (Werbeblocker), bricht das ab und zeigt eine Fehlermeldung, obwohl der Artikel im Warenkorb liegt. */
      if (add && typeof window.reinitialiseRatingSnippet !== 'function') { window.reinitialiseRatingSnippet = function () {}; }
      var antwort = origFetch.apply(window, arguments);
      if (add) {
        verlassen = false;
        horche(true);
        antwort.then(function (res) {
          if (res && res.ok) { res.clone().json().then(nachAdd, function () { horche(false); }); } else { horche(false); }
        }, function () { horche(false); });
      }
      return antwort;
    };
  }

  if (window.XMLHttpRequest) {
    var xOpen = XMLHttpRequest.prototype.open;
    var xSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (methode, url) {
      this.__mhAtcAdd = istAdd(url, methode);
      return xOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this.__mhAtcAdd) {
        var x = this;
        verlassen = false;
        horche(true);
        x.addEventListener('loadend', function () {
          if (x.status >= 200 && x.status < 300) { try { nachAdd(JSON.parse(x.responseText)); return; } catch (e) {} }
          horche(false);
        });
      }
      return xSend.apply(this, arguments);
    };
  }

  function passt(it) {
    if (!it || !it.handle || !it.variant_id) { return false; }
    if (it.gift_card) { return false; }
    if (!(Number(it.final_price) > 0)) { return false; }
    var pr = it.properties || {};
    for (var k in pr) {
      if (Object.prototype.hasOwnProperty.call(pr, k)) {
        if (k === '_q' || k === '_upsell_for' || k.indexOf('__as') === 0) { return false; }
      }
    }
    var typ = String(it.product_type || '').toLowerCase().replace(/^\s+|\s+$/g, '');
    return ohneTypen.indexOf(typ) === -1;
  }

  function nachAdd(json) {
    var liste = json && !cfg.korbseite ? (json.items ? json.items : (json.variant_id ? [json] : [])) : [];
    var it = null;
    for (var i = 0; i < liste.length; i++) {
      if (passt(liste[i])) { it = liste[i]; break; }
    }
    /* kurz warten: Leitet die Seite direkt nach dem Hinzufügen weiter, bleibt das Pop-up weg */
    setTimeout(function () {
      horche(false);
      if (it && !verlassen) { oeffne(it); }
    }, 120);
  }

  /* ---------- Öffnen / Schließen ---------- */
  function geld(cent) {
    var w = cfg.waehrung || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try { return (Number(cent) / 100).toLocaleString('de-DE', { style: 'currency', currency: w }); } catch (e) { return (Number(cent) / 100).toFixed(2).replace('.', ',') + ' ' + w; }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  function platzhalter(it) {
    var bild = it.image ? String(it.image) : '';
    if (bild && /^(https?:)?\/\//.test(bild) && !/[?&]width=/.test(bild)) { bild += (bild.indexOf('?') === -1 ? '?' : '&') + 'width=160'; }
    var variante = it.variant_title && !/default title/i.test(it.variant_title) ? '<span class="mh-atc__prod-var">' + esc(it.variant_title) + '</span>' : '';
    return '<div class="mh-atc__prod">' +
      (bild ? '<span class="mh-atc__prod-bild"><img src="' + esc(bild) + '" alt="" width="64" height="64"></span>' : '<span class="mh-atc__prod-bild"></span>') +
      '<span class="mh-atc__prod-txt"><span class="mh-atc__prod-name">' + esc(it.product_title || it.title) + '</span>' + variante + '</span>' +
      '<span class="mh-atc__prod-preis wg-notranslate" data-wg-notranslate>' + esc(geld(it.final_price)) + '</span></div>' +
      '<div class="mh-atc__lade" aria-hidden="true"><span></span><span></span></div>';
  }

  function cssBereit(fertig) {
    var probe = window.getComputedStyle ? getComputedStyle(doc.documentElement).getPropertyValue('--mh-atc-geladen') : '1';
    if (String(probe).replace(/\s/g, '') === '1') { fertig(); return; }
    var link = doc.getElementById('mh-atc-css');
    var erledigt = false;
    function weiter() { if (!erledigt) { erledigt = true; fertig(); } }
    if (link) { link.media = 'all'; link.addEventListener('load', weiter); }
    setTimeout(weiter, 1500);
  }

  function oeffne(it) {
    aktuell = { handle: it.handle, variante: it.variant_id, typ: it.product_type || '' };
    if (!offen) {
      ausloeser = doc.activeElement && doc.activeElement !== doc.body && !root.contains(doc.activeElement) ? doc.activeElement : letzterKlick;
    }
    offen = true;
    body.innerHTML = platzhalter(it);
    cssBereit(function () {
      if (!offen) { return; }
      root.hidden = false;
      doc.documentElement.classList.add('mh-atc-offen');
      /* erst sichtbar machen, Layout erzwingen, dann animieren */
      void root.offsetWidth;
      root.classList.add('is-offen');
      if (!sichtbar) {
        sichtbar = true;
        try { dialog.focus({ preventScroll: true }); } catch (e) { dialog.focus(); }
        melde('shown', { art: '' });
      }
    });
    ansage((it.product_title || it.title || 'Artikel') + ' liegt im Warenkorb.');
    ladeInhalt(false);
  }

  function schliesse() {
    if (!offen) { return; }
    offen = false;
    sichtbar = false;
    root.classList.remove('is-offen');
    doc.documentElement.classList.remove('mh-atc-offen');
    var weg = function () { if (!offen) { root.hidden = true; body.innerHTML = ''; } };
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { weg(); } else { setTimeout(weg, 260); }
    if (ausloeser && doc.contains(ausloeser) && ausloeser.offsetParent !== null && typeof ausloeser.focus === 'function') {
      try { ausloeser.focus({ preventScroll: true }); } catch (e) {}
    }
    ausloeser = null;
    melde('close', { art: '' });
  }

  /* ---------- Inhalt laden ---------- */
  function ladeInhalt(nachDazu) {
    if (!aktuell || !origFetch) { return; }
    var nr = ++ladeNr;
    var versuch = arguments[1] || 0;
    var url = wurzel + 'products/' + encodeURIComponent(aktuell.handle) + '?view=mh-atc&variant=' + encodeURIComponent(aktuell.variante) + '&_mh=' + Date.now() + versuch;
    var holeInhalt = origFetch(url, { credentials: 'same-origin', cache: 'no-store', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : ''; });
    var holeKorb = origFetch(wurzel + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); }).catch(function () { return null; });
    Promise.all([holeInhalt, holeKorb])
      .then(function (erg) {
        var html = erg[0], korbJetzt = erg[1];
        if (nr !== ladeNr || !offen) { return; }
        if (!html || html.indexOf('data-mh-atc-inhalt') === -1) { entferneLade(); return; }
        /* Schutz gegen einen Seiten-Cache (z. B. Speed Kit): Stimmt die Artikelzahl nicht mit /cart.js überein, einmal neu laden */
        var m = /data-anzahl="(\d+)"/.exec(html);
        if (korbJetzt && m && parseInt(m[1], 10) !== korbJetzt.item_count && versuch < 1) {
          setTimeout(function () { if (nr === ladeNr && offen) { ladeInhalt(nachDazu, versuch + 1); } }, 300);
          return;
        }
        var fokusSchluessel = null;
        if (nachDazu && dialog.contains(doc.activeElement)) {
          var reihe = doc.activeElement.closest ? doc.activeElement.closest('[data-mh-atc-row]') : null;
          fokusSchluessel = reihe ? reihe.getAttribute('data-mh-atc-row') : null;
        }
        /* vom Kunden geöffnete Frage-Zeilen merken (nur nach dem Dazulegen; beim ersten Laden gibt es noch keine) */
        var offeneFragen = [];
        if (nachDazu) {
          Array.prototype.forEach.call(body.querySelectorAll('details[data-mh-atc-frage][open]'), function (d) {
            offeneFragen.push(d.getAttribute('data-mh-atc-frage'));
          });
        }
        /* Warenkorb-Zähler im Kopf nachziehen, falls der Weg zum Warenkorb das Theme nicht informiert hat (eigene Knöpfe) */
        if (!nachDazu && korbJetzt) {
          var zaehler = doc.querySelector('cart-count');
          if (zaehler && parseInt(zaehler.textContent, 10) !== korbJetzt.item_count) {
            doc.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: korbJetzt } }));
          }
        }
        var scroll = body.scrollTop;
        body.innerHTML = html;
        eindeutigeIds(body);
        body.scrollTop = scroll;
        magicWeeks();
        /* geöffnete Frage-Zeile wieder öffnen – nicht, wenn sie jetzt „liegt bei“ meldet (bleibt zu) */
        offeneFragen.forEach(function (k) {
          var d = body.querySelector('details[data-mh-atc-frage="' + k + '"]');
          if (d && !d.hasAttribute('data-dabei')) { d.open = true; }
        });
        if (nachDazu) {
          var ziel = fokusSchluessel ? body.querySelector('[data-mh-atc-row="' + fokusSchluessel + '"] [data-mh-atc-add]') : null;
          try { (ziel || dialog).focus({ preventScroll: true }); } catch (e) {}
        }
      }, entferneLade);
  }
  function entferneLade() {
    var l = body.querySelector('.mh-atc__lade');
    if (l) { l.parentNode.removeChild(l); }
  }

  /* IDs im nachgeladenen Inhalt eindeutig machen (das alte Modal steht noch, ausgeblendet, im DOM) */
  function eindeutigeIds(el) {
    var map = {};
    Array.prototype.forEach.call(el.querySelectorAll('[id]'), function (n) {
      if (n.tagName === 'SCRIPT') { return; }
      var alt = n.id; var neu = alt + '-mhatc'; map[alt] = neu; n.id = neu;
    });
    Array.prototype.forEach.call(el.querySelectorAll('[aria-labelledby],[aria-describedby],[for]'), function (n) {
      ['aria-labelledby', 'aria-describedby', 'for'].forEach(function (a) {
        var v = n.getAttribute(a);
        if (v) { n.setAttribute(a, v.split(/\s+/).map(function (x) { return map[x] || x; }).join(' ')); }
      });
    });
  }

  /* MagicWeeks-Fortschritt im Pop-up: vorhandenes Skript nachziehen lassen, sonst einmal laden */
  function magicWeeks() {
    if (!body.querySelector('[data-mhmw]')) { return; }
    if (window.MHMagicWeeks && typeof window.MHMagicWeeks.aktualisiere === 'function') {
      try { if (!window.MHMagicWeeks.korb().bekannt) { window.MHMagicWeeks.init(); } window.MHMagicWeeks.aktualisiere(); } catch (e) {}
      return;
    }
    if (cfg.mwJs && !doc.querySelector('script[data-mh-atc-mw]')) {
      var s = doc.createElement('script');
      s.src = cfg.mwJs; s.defer = true; s.setAttribute('data-mh-atc-mw', '');
      doc.head.appendChild(s);
    }
  }

  /* ---------- Dazulegen ---------- */
  function dazu(btn) {
    if (btn.getAttribute('aria-busy') === 'true' || btn.classList.contains('is-ok')) { return; }
    var reihe = btn.closest('[data-mh-atc-row]');
    var alt = reihe ? reihe.querySelector('.mh-atc__fehler') : null;
    if (alt) { alt.parentNode.removeChild(alt); }
    var art = btn.getAttribute('data-art') || 'zubehoer';
    var name = btn.getAttribute('data-name') || '';
    var props = { _q: 'popup' };
    if (btn.getAttribute('data-fuer')) {
      props._upsell_for = String(btn.getAttribute('data-fuer'));
      if (btn.getAttribute('data-label')) { props['Gehört zu'] = btn.getAttribute('data-label'); }
    }
    btn.setAttribute('aria-busy', 'true');
    laufend++;
    origFetch(wurzel + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.getAttribute('data-id'), 10), quantity: 1, properties: props }] })
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) { throw j; } return j; }); })
      .then(function () {
        btn.removeAttribute('aria-busy');
        btn.classList.add('is-ok');
        btn.textContent = '✓ Hinzugefügt';
        if (reihe) { reihe.classList.add('is-ok'); }
        ansage(name + ' hinzugefügt.');
        melde('add', { art: art, name: name });
        return korbNeu();
      })
      .then(function () { fertig(); ladeInhalt(true); }, function (err) {
        fertig();
        btn.removeAttribute('aria-busy');
        if (btn.classList.contains('is-ok')) { return; }
        var p = doc.createElement('p');
        p.className = 'mh-atc__fehler';
        p.setAttribute('role', 'alert');
        p.textContent = (err && (err.description || err.message)) || 'Das hat nicht geklappt. Bitte versuch es noch einmal.';
        if (reihe) { reihe.appendChild(p); }
      });
  }
  function fertig() {
    laufend = Math.max(0, laufend - 1);
    if (!laufend && wartendAufKorb) { var f = wartendAufKorb; wartendAufKorb = null; f(); }
  }
  /* Fußzeile „Im Warenkorb: N Artikel · Betrag“ sofort nachziehen (der nachgeladene Inhalt bringt dann die Server-Werte) */
  function summe(cart) {
    if (!cart || typeof cart.item_count !== 'number') { return; }
    var n = body.querySelector('[data-mh-atc-anzahl]');
    var b = body.querySelector('[data-mh-atc-betrag]');
    if (n) { n.textContent = String(cart.item_count); }
    if (b && typeof cart.total_price === 'number') { b.textContent = geld(cart.total_price); }
  }
  function korbNeu() {
    return origFetch(wurzel + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        summe(cart);
        var h = doc.documentElement;
        h.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        h.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
      }, function () {
        doc.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      });
  }

  /* ---------- Bedienung ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    var add = t.closest('[data-mh-atc-add]');
    if (add) { e.preventDefault(); dazu(add); return; }
    if (t.closest('[data-mh-atc-zu]')) { e.preventDefault(); schliesse(); return; }
    var korb = t.closest('[data-mh-atc-korb]');
    if (korb) {
      korb.classList.add('is-laedt');
      melde('cart', { art: '' });
      if (laufend) {
        e.preventDefault();
        var ziel = korb.getAttribute('href');
        wartendAufKorb = function () { window.location.href = ziel; };
        setTimeout(function () { if (wartendAufKorb) { wartendAufKorb(); wartendAufKorb = null; } }, 6000);
      }
    }
  });

  doc.addEventListener('keydown', function (e) {
    if (!sichtbar) { return; }
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); schliesse(); return; }
    if (e.key !== 'Tab') { return; }
    var f = Array.prototype.filter.call(dialog.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])'), function (n) { return n.offsetParent !== null; });
    if (!f.length) { e.preventDefault(); dialog.focus(); return; }
    var erst = f[0], letzt = f[f.length - 1];
    if (e.shiftKey && (doc.activeElement === erst || doc.activeElement === dialog)) { e.preventDefault(); letzt.focus(); }
    else if (!e.shiftKey && doc.activeElement === letzt) { e.preventDefault(); erst.focus(); }
  });
  /* Fokus bleibt im Dialog, auch wenn z. B. Quick-Buy beim Schließen den Fokus zurücksetzt */
  doc.addEventListener('focusin', function (e) {
    if (sichtbar && e.target && !root.contains(e.target)) {
      try { dialog.focus({ preventScroll: true }); } catch (x) {}
    }
  });

  function ansage(text) {
    if (!live) { return; }
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 40);
  }

  /* Messung im Browser (optional): GTM-dataLayer und Microsoft Clarity, falls vorhanden */
  function melde(aktion, d) {
    try {
      if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        window.dataLayer.push({ event: 'mh_atc_popup', mh_aktion: aktion, mh_angebot: d.art || '', mh_produkt_typ: aktuell ? aktuell.typ : '' });
      }
      if (typeof window.clarity === 'function') {
        window.clarity('event', 'mh_atc_' + aktion + (d.art ? '_' + d.art : ''));
      }
    } catch (e) {}
  }

  window.MHAtcPopup = { oeffne: oeffne, schliesse: schliesse, version: '2026.10.14' };
})();
